import { handleActions } from 'redux-actions';
import { CHECK_FEATURES, SET_MODAL_STATE } from 'actions/feature-detection-actions';

export const initialState = {
  featuresToCheck: [],
  isModalOpen: false,
};

const reducer = handleActions(
  {
    // setting state to initial state resets the list of features before every request
    [CHECK_FEATURES]: (state = initialState, action) => ({
      ...state,
      featuresToCheck: action.payload,
    }),
    [SET_MODAL_STATE]: (state, action) => ({
      ...state,
      isModalOpen: action.payload,
    }),
  },
  initialState
);

export default reducer;
